/**
 * DARangesService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DARangesService {
    getDARangeMetrics = () => {
        return apiClient.get("/ranges/metricsList");
    }

    getDARangeMetricsData = (body) => {
        return apiClient.post("/dataAnalysis/ranges", body);
    }
}
